import React, { useEffect, useState } from 'react';
import API from '../../../pages/Api';
import { toast } from 'react-toastify';
import { fetchNonResidenceUsers } from '../../../pages/Services';
import TableContainer from '../../common/Tablecontainer';
import { gender as genderMapping, residence as residenceMapping } from '../../../constant/constants';

const NonResidence = () => {
    const [users, setUsers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true);
    const [selectedUser, setSelectedUser] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [userCourses, setUserCourses] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const loadNonResidenceData = async () => {
        setLoading(true);
        try {
            const response = await fetchNonResidenceUsers(currentPage, searchQuery);
           
            setUsers(response.results || response); 
            setTotalPages(response.total_pages || 1);
        } catch (err) {
            console.error(err);
            toast.error("Failed to fetch users");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadNonResidenceData();
    }, [currentPage, searchQuery]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const openCourseModal = async (user) => {
        setSelectedUser(user);
        setShowModal(true);
        try {
            const userId = user.userid || user.userId;
            const res = await API.get(`getAllUserDtlsById?userId=${userId}`);
            const rawCourses = res.data.courseData || [];
            setUserCourses(rawCourses);
        } catch (err) {
            console.error("Error fetching courses:", err);
            setUserCourses([]);
        }
    };

    const handleActivateCourse = async (course) => {
        if (course.status === 'SUCCESS') return;
        if (!window.confirm(`Activate ${course.courseName}?`)) return;

        const token = localStorage.getItem('access_token');
        if (!token) {
            toast.error("Session expired!");
            return;
        }

        const payload = {
            paymentdataid: parseInt(course.paymentDataId, 10),
            targetCourseId: parseInt(course.courseId, 10)
        };

        try {
            const res = await API.post('admin/approve-pending-cash-transaction/', payload, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            });
            if (res.status === 200) {
                toast.success("Success: " + res.data.message);
                setShowModal(false);
                loadNonResidenceData(); 
            }
        } catch (err) {
            toast.error("Activation failed: " + (err.response?.data?.detail || "Error"));
        }
    };

    if (loading && users.length === 0) return <div className="flex justify-center items-center h-60">Loading...</div>;

    return (
        <div className="p-4 md:p-6 font-sans">
            <h2 className="text-center text-2xl md:text-4xl font-light text-gray-700 mb-6">Non Residence Users</h2>
            
            <div className="mb-5">
                <input
                    type="text"
                    placeholder="Search Name / Email / Mobile"
                    value={searchQuery}
                    onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                    className="w-full border rounded-lg p-3 outline-none"
                />
            </div>

            {isMobile ? (
                <div className="space-y-4">
                    {users.map((user, index) => (
                        <div key={user.userid || index} className="bg-white rounded-xl shadow border p-4">
                            <div className="flex justify-between items-center mb-3">
                                <h3 className="font-bold text-[#032167] text-base">{user.name}</h3>
                                <span className="text-xs text-gray-400">#{(currentPage - 1) * 10 + index + 1}</span>entPage
                            </div>
                            <div className="text-sm space-y-1">
                                <p><span className="font-semibold">Email:</span> {user.emailid}</p>
                                <p><span className="font-semibold">Contact:</span> {user.mobileno || "-"}</p>
                                <p><span className="font-semibold">Resident:</span> {residenceMapping[user.residence] || "N/A"}</p>
                            </div>
                            <button onClick={() => openCourseModal(user)} className="mt-4 w-full bg-[#032167] text-white py-2 rounded-lg text-xs font-bold uppercase">
                                Manage
                            </button>
                        </div>
                    ))}
                    {/* Mobile Pagination */}
                    <div className="flex justify-between items-center mt-4">
                        <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} className="px-3 py-1 bg-gray-200 rounded">Prev</button>
                        <span>{currentPage} / {totalPages}</span>
                        <button disabled={currentPage >= totalPages} onClick={() => setCurrentPage(p => p + 1)} className="px-3 py-1 bg-gray-200 rounded">Next</button>
                    </div>
                </div>
            ) : (
                // Table view remains as it was
            //     <TableContainer 
            //         columns={['Date', 'Name', 'Email', 'Contact', 'Resident', 'Gender', 'Action']}
            //         data={users}
            //         renderRow={(user, index, srNo) => (
            //             <tr key={user.userid} className="border-b text-sm">
            //                 <td className="p-3">{srNo}</td>
            //                 <td className="p-3">{new Date(user.createddate).toLocaleDateString()}</td>
            //                 <td className="p-3 font-bold text-blue-600">{user.name}</td>
            //                 <td className="p-3">{user.emailid}</td>
            //                 <td className="p-3">{user.mobileno}</td>
            //                 <td className="p-3">{residenceMapping[user.residence]}</td>
            //                 <td className="p-3 text-center">
            //                     <button onClick={() => openCourseModal(user)} className="bg-[#032167] text-white px-3 py-1 rounded text-xs">Manage</button>
            //                 </td>
            //             </tr>
            //         )}
            //     />
            // )}
                <TableContainer
                columns={['Date', 'Name', 'Email', 'Contact', 'Resident', 'Gender', 'Action']}
                apiUrl="admin/users/non-residence/"
                renderRow={(user,index,srNo,refreshTable)=>(

                <tr
                key={user.userid || index}
                className="border-b hover:bg-gray-50 text-xs text-gray-700"
                >

                <td className="p-3 border-r text-center font-bold">
                {srNo}
                </td>

                <td className="p-3 border-r text-center">
                {
                user.createddate
                ?
                new Date(user.createddate).toLocaleDateString("en-GB")
                :
                "N/A"
                }
                </td>

                <td className="p-3 border-r font-bold text-blue-600 uppercase">
                {user.name}
                </td>

                <td className="p-3 border-r font-mono text-gray-500">
                {user.emailid}
                </td>

                <td className="p-3 border-r">
                {user.mobileno}
                </td>

                <td className="p-3 border-r">
                {residenceMapping[user.residence] || "N/A"}
                </td>

                <td className="p-3 border-r">
                {genderMapping[user.gender] || "-"}
                </td>

                <td className="p-3 text-center">

                <button
                onClick={()=>openCourseModal(user)}
                className="bg-[#032167] text-white px-4 py-1.5 rounded text-[10px] font-bold uppercase hover:bg-blue-950"
                >
                Manage
                </button>

                </td>

                </tr>

                )}
                />

                )
                }



            {/* --- ACTIVATION MODAL (Manage Courses View) --- */}
            {/* --- CREATIVE ACTIVATION MODAL WITH ALL CORRECT COLUMN NAMES --- */}
            {showModal && selectedUser && (
                <div className="fixed inset-0 bg-slate-900/60 flex items-center justify-center z-[1000] p-2 md:p-4 backdrop-blur-sm">
                    <div className="
                    bg-white
                    w-full
                    max-w-5xl
                    h-[75vh]
                    md:h-[90vh]
                    rounded-xl
                    shadow-2xl
                    flex
                    flex-col
                    overflow-hidden
                    ">
                        
                        {/* Modal Header */}
                        <div className="p-3 md:p-6 bg-[#032167] flex justify-between items-start md:items-center text-white gap-3">
                            <div className="flex flex-col">
                                <span className="text-xs font-bold uppercase tracking-widest text-blue-200">
                                    Non-Residence User Management Matrix
                                </span>
                                <h3 className="text-sm md:text-xl font-bold break-words">
                                    Manage Courses for: <span className="text-emerald-400">{selectedUser.name}</span>
                                </h3>
                            </div>
                            <button 
                                onClick={() => setShowModal(false)} 
                                className="text-white hover:text-red-400 bg-white/10 hover:bg-white/20 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full text-2xl font-light transition-all cursor-pointer shadow-inner"
                            >
                                &times;
                            </button>
                        </div>
                        
                        {/* Disclaimer */}
                        <div className="bg-amber-50 py-2 text-center text-[10px] md:text-[11px] font-bold text-amber-700 uppercase border-b border-amber-100 px-2">
                            ⚠️ Warning: International Profiles Registry — Confirm complete USD remittance before processing activation
                        </div>

                        {/* Modal Content - C<orrected Columns Fitted Perfectly On Single Screen */}
                        <div className="flex-1 overflow-auto bg-slate-50 p-3 md:p-6">
                            <div className="w-full overflow-x-auto bg-white rounded-xl border border-gray-200 shadow-sm">
                                <table className="min-w-[850px] w-full border-collapse text-center">
                                    <thead className="bg-slate-100 text-slate-600 text-[10px] md:text-[11px] font-bold uppercase tracking-widest border-b border-gray-200 ">
                                        <tr>
                                            {/* 🟢 All required column names included explicitly */}
                                            <th className="p-4 border-r text-left pl-6 font-semibold">Course Description</th>
                                            <th className="p-4 border-r font-semibold">Transaction amount(USD)</th>
                                            <th className="p-4 border-r font-semibold">Duration </th>
                                            <th className="p-4 border-r font-semibold">Registration Date</th> 
                                            <th className="p-4 border-r font-semibold">Payment Status</th>
                                            <th className="p-4 border-r font-semibold text-center">Action</th>
                                        </tr>                                    
                                        
                                    </thead>
                                    <tbody className="text-xs md:text-[13px] divide-y divide-gray-100 font-medium text-slate-700">
                                        {userCourses.length > 0 ? userCourses.map((c, i) => {
                                            const calculatedUsdFee = c.amountDollar || (c.amount && c.amount !== "None" ? (parseFloat(c.amount) / 84).toFixed(2) : "0.00");

                                            return (
                                                <tr 
                                                    key={c.paymentDataId ? `${c.courseId}_${c.paymentDataId}` : `${c.courseId}_${i}`} 
                                                    className="hover:bg-slate-50/80 transition-colors duration-150"
                                                > 
                                                    {/* 1. Course Description */}
                                                    <td className="p-4  border-r text-left pl-6 font-bold text-slate-800 uppercase tracking-tight max-w-[260px] break-words">
                                                        {c.courseName || "N/A"}
                                                    </td>
                                                    
                                                    {/* 2. Remittance Fee */}
                                                    <td className="p-4 border-r font-mono font-bold text-green-700 text-sm whitespace-nowrap">
                                                        ${parseFloat(calculatedUsdFee).toFixed(2)}
                                                    </td>
                                                    
                                                    {/* 3. Duration Cycle */}
                                                    <td className="p-4 border-r text-slate-500 font-semibold whitespace-nowrap">
                                                        {c.duration ? `${c.duration} Days` : "N/A"}
                                                    </td>
                                                    
                                                    {/* 4. Registration Date */}
                                                    <td className="p-4 border-r text-slate-500 font-mono text-xs whitespace-nowrap">
                                                        {c.activationDate || "N/A"}
                                                    </td>
                                                    
                                                    {/* 5. Payment Status */}
                                                    <td className="p-4 border-r whitespace-nowrap">
                                                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs md:text-[10px] font-bold uppercase tracking-wider border ${
                                                            c.status?.toUpperCase() === 'SUCCESS' 
                                                                ? 'bg-emerald-50 text-emerald-700 border-emerald-200' 
                                                                : 'bg-amber-50 text-amber-700 border-amber-200'
                                                        }`}>
                                                            <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
                                                                c.status?.toUpperCase() === 'SUCCESS' ? 'bg-emerald-500' : 'bg-amber-500'
                                                            }`}></span>
                                                            {c.status?.toUpperCase() || 'PENDING'}
                                                        </span>
                                                    </td>
                                                    
                                                    {/* 6. Lifecycle Action Button */}
                                                    <td className="p-4 text-center whitespace-nowrap">
                                                        {c.status?.toUpperCase() === 'PENDING' ? (
                                                            <button 
                                                                onClick={() => handleActivateCourse(c)} 
                                                                className="bg-emerald-600 text-white px-3 md:px-5 py-2 rounded-lg text-[10px] md:text-xs font-bold hover:bg-emerald-700"
                                                            >
                                                                Activate Now
                                                            </button>
                                                        ) : (
                                                            <span className="inline-flex items-center text-emerald-600 font-bold text-[11px] uppercase tracking-widest bg-emerald-50 px-3 py-1.5 rounded border border-emerald-100">
                                                                ✓ Activated
                                                            </span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        }) : (
                                            <tr>
                                                <td colSpan="6" className="py-12 text-center text-slate-400 font-medium text-sm bg-slate-200/10">
                                                    <div className="flex flex-col items-center justify-center space-y-2">
                                                        <span className="text-2xl">📋</span>
                                                        <span>No processing history course logs found.</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NonResidence;


